import {
    afterEveryRender,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
} from '@angular/core';

@Component({
    selector: 'qpx-preview-control-group',
    template: '<ng-content />',
    styleUrl: './preview-control-group.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewControlGroup {
    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    constructor() {
        afterEveryRender(() => {
            const controls = Array.from(
                this.host.nativeElement.querySelectorAll<HTMLElement>(
                    'button.mat-mdc-icon-button, input.zoom-input, .page-indicator'
                )
            );
            const visible = controls.filter(
                (control) => control.getClientRects().length > 0
            );
            for (const control of controls) {
                control.classList.toggle(
                    'preview-control-start',
                    control === visible[0]
                );
                control.classList.toggle(
                    'preview-control-end',
                    control === visible.at(-1)
                );
            }
        });
    }
}
